<div *ngIf="hasFinalResult()">
    <valg-table
    [columnDefinition]="topCandidatesColumnDef"
    [data]="data"
    [itemName]="'top_candidates.table.item_name' | translate"
    [noDataMessage]="'top_candidates.table.no_data_row'"
    [title]="'top_candidates.title' | translate"
    [hasPagination]="false"
    [displayItemCount]="false"
    [hasMainActionButton]="false">
        <h2 class="m-0 text--f20 text--500">{{ 'top_candidates.title' | translate }}</h2>
        <valg-dk-result-summary content-position="pre-table" [resultSummary]="resultSummary"></valg-dk-result-summary>
    </valg-table>
</div>
<valg-card-information-content *ngIf="!hasFinalResult()"
    [title]="'top_candidates.title' | translate"
    [message]="'top_candidates.no_results' | translate">
</valg-card-information-content>
